import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { PermissionMetadata } from '../../../../typings/api';

export const allPermissionsQueryKey: QueryKey = ['roles', 'all-permissions'];

function fetchAllPermissions() {
  return get<PermissionMetadata[]>('/api/roles/all-permissions');
}

/**
 * Fetch all of the available permissions that can be assigned to custom roles.
 */
export default function useAllPermissionsQuery() {
  return useQuery<PermissionMetadata[]>({
    queryKey: allPermissionsQueryKey,
    queryFn: fetchAllPermissions,
    staleTime: 1000 * 60 * 5,
  });
}
